<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import moment from "moment";

import { onMounted, ref } from "vue";


const props = defineProps(['domainHistory']);

const sortType = ref('');
const domains = ref([]);

function sortBy() {
  if (sortType.value === '') {
    sortType.value = 'ASC';
  } else if (sortType.value === 'ASC') {
    sortType.value = 'DESC';
  } else if (sortType.value === 'DESC') {
    sortType.value = '';
  }
}

function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
}

function sortTableData(column) {
  if (sortType.value === '') {
    return domains.value;
  } else if (sortType.value === 'ASC') {
    return domains.value.sort((a, b) => a[column] > b[column] ? 1 : -1);
  } else if (sortType.value === 'DESC') {
    return domains.value.sort((a, b) => a[column] < b[column] ? 1 : -1);
  }
}

onMounted(() => {
  // console.log('mounted DomainHistoryDataTable', this.domainHistory);
});
</script>

<template>
  <div>
    <el-row
      v-if="domainHistory.length>0"
      class="px-4"
    >
      <el-col
        v-if="domainHistory.length>0"
        :span="24"
      >
        <div class="table table-dns table-not-mobile pt-0 px-4">
          <table>
            <thead>
              <tr>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">NOMBRE</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">ASCII NAME</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">SUBDOMINIO</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">ESTADO</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">PLAN</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">WEB</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">DNS</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">CORREO</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">FECHA INICIO</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">FECHA FIN</span>
                  </div>
                </th>
                <th>
                  <div class="d-flex justify-content-start">
                    <span class="mt-1">ACTUALIZADO</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="domain in domainHistory"
                :key="domain.id"
              >
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ domain.name }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ domain.ascii_name }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">
                      <font-awesome-icon
                        v-if="domain.subdomain"
                        style="color: green"
                        icon="check-circle"
                      />
                      <font-awesome-icon
                        v-else
                        style="color: red"
                        icon="times-circle"
                      />
                    </span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      v-if="domain.status === 'active'"
                      style="color: green"
                      icon="check-circle"
                    />
                    <font-awesome-icon
                      v-else-if="domain.status === 'disabled'"
                      style="color: red"
                      icon="times-circle"
                    />
                    <font-awesome-icon
                      v-else-if="domain.status === 'suspended'"
                      style="color: orange"
                      icon="exclamation-circle"
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ domain.planName }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      v-if="domain.ipActive"
                      style="color: green"
                      icon="check-circle"
                    />
                    <font-awesome-icon
                      v-else
                      style="color: red"
                      icon="times-circle"
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      v-if="domain.dnsInServer"
                      style="color: green"
                      icon="check-circle"
                    />
                    <font-awesome-icon
                      v-else
                      style="color: red"
                      icon="times-circle"
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      v-if="domain.mxActive"
                      style="color: green"
                      icon="check-circle"
                    />
                    <font-awesome-icon
                      v-else
                      style="color: red"
                      icon="times-circle"
                    />
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(domain.dateStart) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(domain.dateEnd) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="ml-2">{{ formatDateTime(domain.lastUpdate) }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-mobile px-2">
          <el-row
            v-for="domain in domainHistory"
            :key="domain.id"
            class="mt-2"
          >
            <el-card class="domain-history-mobile-card w-100">
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">Nombre:</span>
                <span>{{ domain.name || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">ASCII name:</span>
                <span>{{ domain.ascii_name || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">Subdominio:</span>
                <span>{{ domain.subdomain ? 'Si' : 'No' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span><b class="domain-history-mobile-card__label">Estado:</b>
                {{ domain.status || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span><b class="domain-history-mobile-card__label">Plan:</b>
                {{ domain.planName || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span><b class="domain-history-mobile-card__label">Web:</b>
                {{ domain.ipActive ? 'Si' : 'No' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span><b class="domain-history-mobile-card__label">DNS:</b>
                {{ domain.dnsInServer ? 'Si' : 'No' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span><b class="domain-history-mobile-card__label">Correo:</b>
                {{ domain.mxActive ? 'Si' : 'No' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">Fecha inicio:</span>
                <span>{{ formatDateTime(domain.dateStart) || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">Fecha fin:</span>
                <span>{{ formatDateTime(domain.dateEnd) || '--' }}</span>
              </div>
              <div class="domain-history-mobile-card__item">
                <span class="domain-history-mobile-card__label">Actualizado:</span>
                <span>{{ formatDateTime(domain.lastUpdate) || '--' }}</span>
              </div>
            </el-card>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">

.table-dns {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }
    }

    tbody {
      td {
        letter-spacing: -0.05em;

        font-weight: bolder;

        letter-spacing: -0.05em;
        font-size: 0.9em;

        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}

.table-mobile {
  display: none;
}

.domain-history-mobile-card {
  border-radius: 18px;
}

.domain-history-mobile-card :deep(.el-card__body) {
  padding: 16px 16px 18px;
}

.domain-history-mobile-card__item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 10px;
  word-break: break-word;
}

.domain-history-mobile-card__item:last-child {
  margin-bottom: 0;
}

.domain-history-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
